
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'
import JsonDebug from '../ui-elements/JsonDebug'
import Modal from '../ui-elements/Modal'
import SelectRecursiveFolder from './SelectRecursiveFolder'

type Props = {
    folders: ObjectStringKeyAnyValue
    setItemToMove: React.Dispatch<React.SetStateAction<any>>
    itemToMove: ObjectStringKeyAnyValue
    moveItemToNewParentFolder: AnyFunction

}


function MoveToFolder({
    folders,
    setItemToMove,
    itemToMove,
    moveItemToNewParentFolder
}: Props) {

    const {
        tableData

    } = useContext(GlobalContext)

    const [selectedFolderId, setSelectedFolderId] = useState<string | null>(itemToMove.ParentFolderId || null)

    


    return <Modal>
        <div className={`w-full flex flex-col gap-4 items-center justify-center`}>
            <h3 className={`text-3xl font-brandblue font-righteous`}>Select folder to move to:</h3>

                {/* <JsonDebug jsonobject={itemToMove} />
                new parentid: [
                    {selectedFolderId === null && 'null'}
                    {selectedFolderId === '' && '--'}
                    {selectedFolderId && selectedFolderId}
                    ]  */}


            <SelectRecursiveFolder
                folders={folders}
                setSelectedFolderId={setSelectedFolderId}
                selectedFolderId={selectedFolderId}
                itemToMove={itemToMove}
                showTopLevel={true}
                
            />

            <div className={`w-full flex flex-row gap-1`}>
                <Button
                    onClick={() => setItemToMove(null)}
                    text='Cancel'
                    variant='gray'
                    size='big'
                />

                <Button
                    onClick={() => moveItemToNewParentFolder(itemToMove, selectedFolderId)}
                    text='Ok'
                    variant={selectedFolderId !== null && selectedFolderId !== itemToMove.ParentFolderId ? 'primary' : 'gray'}
                    disabled={selectedFolderId !== null && selectedFolderId !== itemToMove.ParentFolderId ? false : true}
                    size='big'
                />
            </div>
        </div>
    </Modal>
}

export default MoveToFolder